import { Divider } from "@mui/material";
import { grey } from "@mui/material/colors";
import React from "react";

const SectionDivider = ({ vertical, sx, flexItem = true }) => {
  return (
    <Divider
      flexItem={flexItem}
      orientation={vertical ? "vertical" : "horizontal"}
      sx={{ my: 5, borderColor: grey[200], ...sx }}
    />
  );
};
export default SectionDivider;
